import { ArrowRight } from '@phosphor-icons/react'
import { BLOG_POSTS, formatDate } from '@/site/blog'
import { CtaBand, Crumbs } from '@/site/content'
import { breadcrumbList, type Crumb, type PageMeta } from '@/site/meta'
import { SiteShell } from '@/site/SiteShell'

const TRAIL: Crumb[] = [{ name: 'Головна', path: '/' }, { name: 'Блог', path: '/blog' }]

export const meta: PageMeta = {
  title: 'Блог Anytel: дзвінки, клієнти й автоматизація',
  description:
    'Практичні статті для малого бізнесу: як не пропускати дзвінки, порахувати втрати і вирішити, чи потрібен вам AI-агент.',
  schema: [breadcrumbList(TRAIL)],
}

export default function BlogIndex() {
  return (
    <SiteShell>
      <main id="main" className="lp-page">
        <div className="lp-wrap">
          <Crumbs items={TRAIL} />
          <header className="lp-page-head">
            <p className="lp-eyebrow">Блог</p>
            <h1>Блог Anytel</h1>
            <p className="lp-page-lead">
              Практичні статті про дзвінки і клієнтів: що перевірити, як порахувати і що змінити, щоб клієнти
              не губилися на телефоні.
            </p>
          </header>
          <ul className="lp-posts">
            {BLOG_POSTS.map((p) => (
              <li key={p.path}>
                <a href={p.path}>
                  <p className="lp-article-meta">
                    <time dateTime={p.published}>{formatDate(p.published)}</time> · {p.minutes} хв читання
                  </p>
                  <h2>{p.title}</h2>
                  <p>{p.description}</p>
                  <span className="lp-more">Читати <ArrowRight size={16} weight="bold" /></span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <CtaBand />
      </main>
    </SiteShell>
  )
}
